import TableAction from "components/TableAction";
import { useAppContextController } from "context/AppContext";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const InvoiceEditorTableActions = ({
  id,
  row,
  setNavigateUrl,
  isShiftJob,
  onToggleSubList,
  editLocked,
  showInfoButton,
  onSelectRow,
  onDeleteRow,
}) => {
  const { company, userType } = useAppContextController();
  const navigate = useNavigate();

  const navigateLocal = setNavigateUrl ?? navigate;

  const route = row?.slug ? "partners" : "employees";
  const actionroute = row?.slug ? "partners" : "employee";
  const namePrefix = row?.slug ? "Partner" : "Employee";
  const onClickHandler = (action, e) => {
    e.stopPropagation();
    if (action === "employeetoggle") {
      onToggleSubList?.();
      return;
    }
    navigateLocal(`/${route}/${id}/action/${action}`);
  };

  return (
    <span>
      {showInfoButton && !editLocked && (
        <>
          <TableAction
            color="info"
            icon="info"
            clickAction={(e) => onClickHandler(`${actionroute}info`, e)}
            tooltip={`${namePrefix} Info`}
          />
          <TableAction
            color="info"
            icon="edit"
            clickAction={(e) => onSelectRow(row)}
            tooltip="Edit"
          />
          <TableAction
            color="error"
            icon="delete"
            clickAction={(e) => onDeleteRow(row)}
            tooltip="Remove"
          />
        </>
      )}
    </span>
  );
};

export default InvoiceEditorTableActions;

InvoiceEditorTableActions.defaultProps = {
  id: "",
  setNavigateUrl: () => {},
};

// Typechecking props for the TableAction
InvoiceEditorTableActions.propTypes = {
  id: PropTypes.string,
  setNavigateUrl: PropTypes.func,
};
